export default __webpack_public_path__ + "static/media/g.0963d47f.svg";